import { createRouter, createWebHashHistory, type RouteRecordRaw } from "vue-router";
import { authGuard, roleGuard } from "./guards";
import HomeView from "@/features/home/HomeView.vue";
import ProjectView from "@/features/project/ProjectView.vue";
import BoardView from "@/features/board/BoardView.vue";
import KanbanView from "@/features/kanban/KanbanView.vue";
import SprintView from "@/features/sprint/SprintView.vue";
import SignInView from "@/features/auth/SignInView.vue";
import WrongDomainView from "@/features/auth/WrongDomainView.vue";
import AdminUsersView from "@/features/admin/AdminUsersView.vue";
import AdminOnboardView from "@/features/admin/AdminOnboardView.vue";
import AdminProjectsView from "@/features/admin/AdminProjectsView.vue";

const routes: RouteRecordRaw[] = [
  { path: "/signin", name: "signin", component: SignInView, meta: { public: true } },
  { path: "/wrong-domain", name: "wrong-domain", component: WrongDomainView, meta: { public: true } },
  { path: "/403", name: "forbidden", component: WrongDomainView, meta: { public: true, forbidden: true } },
  {
    path: "/",
    name: "home",
    component: HomeView,
    beforeEnter: authGuard,
  },
  {
    path: "/p/:key",
    name: "project",
    component: ProjectView,
    beforeEnter: authGuard,
  },
  {
    path: "/p/:key/kanban",
    name: "project-kanban",
    component: KanbanView,
    beforeEnter: authGuard,
  },
  {
    // Board-first scorecard. Auto-resolves to the sprint dashboard (Scrum) or
    // the rolling-window view (Kanban) by the board's type. A shared board
    // (sprints across projects) renders a per-project breakdown.
    path: "/b/:boardId",
    name: "board",
    component: BoardView,
    beforeEnter: authGuard,
  },
  {
    path: "/p/:key/s/:id",
    name: "sprint",
    component: SprintView,
    beforeEnter: authGuard,
  },
  {
    path: "/admin",
    name: "admin",
    component: AdminUsersView,
    beforeEnter: roleGuard("admin"),
  },
  {
    path: "/admin/onboard",
    name: "admin-onboard",
    component: AdminOnboardView,
    beforeEnter: roleGuard("admin"),
  },
  {
    path: "/admin/senders",
    name: "admin-senders",
    component: AdminProjectsView,
    beforeEnter: roleGuard("admin"),
  },
];

export const router = createRouter({
  history: createWebHashHistory(),
  routes,
});
